(function () {
  function syncRating() {
    var count = document.querySelector('[data-ltw-count]');
    var rating = document.querySelector('[data-ltw-rating]');
    var titleCount = document.querySelector('[data-altair-rating-count]');
    if (!count || !titleCount) return;

    function paint() {
      var value = count.textContent.trim();
      if (value) {
        var lang = document.documentElement.lang.slice(0, 2).toLowerCase();
        var labels = { de: ' Bewertungen', en: ' reviews', fr: ' avis', nl: ' beoordelingen', it: ' recensioni', ja: ' 件のレビュー' };
        titleCount.textContent = value + (labels[lang] || labels.en);
      }
      var score = rating && Number(rating.textContent.trim().replace(',', '.'));
      var stars = titleCount.closest('.alt-ph__rating');
      if (stars && Number.isFinite(score) && score > 0) {
        var fill = stars.querySelector('.alt-ph__stars-fill');
        var label = stars.querySelector('.alt-ph__stars');
        if (fill) fill.style.width = Math.max(0, Math.min(100, score * 20)) + '%';
        if (label) label.setAttribute('aria-label', score + ' / 5');
      }
    }

    paint();
    new MutationObserver(paint).observe(count, { childList: true, characterData: true, subtree: true });
    if (rating) new MutationObserver(paint).observe(rating, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncRating, { once: true });
  else syncRating();
})();
